import { canonicalRedirectUrl } from './lib/canonicalHost';
import { installPrompt } from './lib/installPrompt';
import { platformUrl } from './lib/platformUrl';

// Production: a visit to my-wannablab.web.app moves to my.wannablab.com before
// the app — and with it Firebase Auth — loads, so nothing (an email link's
// one-time code included) is consumed on the old domain. The app is a
// separate chunk for that reason.
const target = import.meta.env.PROD && canonicalRedirectUrl({ href: window.location.href, canonical: platformUrl() });

if (target) {
    window.location.replace(target);
} else {
    installPrompt.capture(window);
    import('./boot');
}
